import { fromJS } from 'immutable'
import React from 'react'
import { getStorageValue, StorageFields } from '../../../storage/browserStorage'
import { getImageLink } from "../table/menu/chat"

/**
 * @param className
 * @param players
 * @param showAuthor: Boolean = false
 * @param showSystem: Boolean = false, whether to show system chat messages
 * This listens to window event of type
 * "--dk-chat:{...}"
 */
class ChatBubble extends React.Component
{

    constructor(props)
    {
        super(props)
        this.state = {
            queue: fromJS([]),
            current: undefined,
            shown: false
        }
        this._listener = evt => {
            if (evt && evt.data && typeof evt.data === "string" && evt.data.startsWith("--dk-chat")) {
                const json = JSON.parse(evt.data.replace(/^--dk-chat:/g, ""))
                let msg = json.message
                if (json.playerId == null && this.props.showSystem)
                {
                    // System chat messages are shown regardless of ALLOW_CHAT settings
                    this.show(null, msg)
                }
                else if (json.playerId != null)
                {
                    const allowChat = getStorageValue(StorageFields.ALLOW_CHAT)
                    const author = this.props.players.find(p => p != null && p.get("id") == json.playerId)
                    if (allowChat != "nobody" && author && (allowChat == "everyone" || author.get("turnIdx") != null)) {
                        this.show(json.playerId, msg)
                    }
                }
            }
        }
    }

    componentDidMount()
    {
        window.addEventListener("message", this._listener, false)
    }

    componentWillUnmount()
    {
        window.removeEventListener("message", this._listener)
    }

    show(playerId, msg)
    {
        this.setState({ queue: this.state.queue.push(fromJS({
            key: Math.random(),
            text: Messages.apply(null, [ msg.message ].concat(msg.messageArgs || [])),
            image: msg.type === "IMAGE" ? msg.message : null,
            playerId: playerId
        })) }, this._next.bind(this))
    }

    _next()
    {
        if (!this.state.shown)
        {
            const current = this.state.queue.size ? this.state.queue.get(0) : null
            this.setState({
                current: current,
                queue: this.state.queue.size ? this.state.queue.remove(0) : fromJS([]),
                shown: current != null
            })
            if (current != null)
            {
                setTimeout(() => {
                    this.setState({ shown: false }, this._next.bind(this))
                }, 2600)
            }
        }
    }

    render()
    {
        if (this.state.shown)
        {
            const current = this.state.current
            const author = this.props.players.find(p => p != null && p.get("id") == current.get("playerId"))
            const authorBadge =  this.props.showAuthor && author ? (
                <div className={ "sent-by-" + (author.get("color").toLowerCase()) }>{ author.get("name") }</div>
            ) : null

            let image = current && current.get("image") ? (
                <img src={ getImageLink(current.get("image")) }></img>
            ) : null

            let text = current && !current.get("image") && current.get("text") ? (
                current.get("text")
            ) : null

            let className = "game-player-chatbox "
                + (authorBadge ? "shows-author " : "") + (this.props.className || "")
                + (image ? " image " : "")

            return (
                <div 
                    key={ current ? current.get("key") : "-" }
                    className={ className }>
                    <div className="arrow"></div>
                    { authorBadge }
                    { image }
                    { text }
                </div>
            )
        }
        return null
    }



}

export default ChatBubble
export { ChatBubble }